// extracted by mini-css-extract-plugin
module.exports = {"hero":"about--hero--214we","callToAction":"about--callToAction--3LOL6","darkSection":"about--darkSection--1x_NL","aboutUsBeach":"about--aboutUsBeach--14lnp"};